/* Nourish Mantra — visible confirmation when something goes into the bag. */
(function () {
  if (window.__nmCartToast) return;
  window.__nmCartToast = true;

  var host;
  function mount() {
    if (host) return host;
    host = document.createElement('div');
    host.className = 'nm-toast';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function popBubble() {
    var nodes = document.querySelectorAll('[data-cart-count], .cart-bubble, .cart-bubble__text, .cart-count, .header__cart-count');
    nodes.forEach(function (n) {
      n.classList.remove('nm-pop');
      void n.offsetWidth;
      n.classList.add('nm-pop');
    });
  }

  var hideTimer;
  function show(item) {
    var el = mount();
    var img = item && item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '';
    var title = item && item.product_title ? item.product_title : 'Added to your bag';
    el.innerHTML =
      '<div class="nm-toast__in">' + img +
      '<div class="nm-toast__t"><b>Added to bag</b><span>' + title.replace(/</g, '&lt;') + '</span></div>' +
      '<a class="nm-toast__cta" href="/cart">View bag</a></div>';
    el.setAttribute('data-on', 'true');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { el.setAttribute('data-on', 'false'); }, 3800);
    popBubble();
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(href)) {
      p.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(function (data) {
          var item = data && (data.items ? data.items[0] : data);
          show(item);
        }).catch(function () { show(null); });
      }).catch(function () {});
    }
    return p;
  };
})();

/* Nourish Mantra — auto slide for horizontal rows on mobile ([data-nm-autoscroll]): one card every few seconds, loops. */
(function () {
  if (window.__nmAutoScroll) return;
  window.__nmAutoScroll = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function setup(el) {
    var paused = false, timer, resumeT, visible = false;
    var every = parseFloat(el.getAttribute('data-nm-autoscroll')) || 2800;
    if (every < 100) every = 2800;
    function pause(ms) { paused = true; clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, ms || 5000); }
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (e) { el.addEventListener(e, function () { pause(5000); }, { passive: true }); });
    function stepW() { var c = el.children[0]; if (!c) return 0; var gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap) || 0; return c.getBoundingClientRect().width + gap; }
    function tick() {
      if (!visible || paused) return;
      var max = el.scrollWidth - el.clientWidth;
      if (max < 8) return;
      var w = stepW();
      if (el.scrollLeft >= max - 4) el.scrollTo({ left: 0, behavior: 'smooth' });
      else el.scrollTo({ left: Math.min(max, el.scrollLeft + w), behavior: 'smooth' });
    }
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.25 }).observe(el);
    timer = setInterval(tick, every);
  }
  function init() {
    if (window.matchMedia('(min-width: 900px)').matches) return;
    document.querySelectorAll('[data-nm-autoscroll]').forEach(function (el) { if (el.__nmAS) return; el.__nmAS = true; setup(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
